export const reservationRulesKeys = {
    all: ['reservationRules'] as const,
    detail: (centerId: string) => ['reservationRules', 'detail', centerId] as const,
};
